/*
 * @Description: 自动生成代码无需修改，可跑npm run services来重新生成
 */
import http from '@lib/http';
import { GetServerSidePropsContext } from 'next';

export interface Body {
  /**
   * 活动ID
   */
  event_id: string;
  /**
   * 活动封面样式
   */
  cover_image_type?: string;
}
/**
 * 活动标签数组
 */
export type Labels = string[];
/**
 * 自定义门票列表
 */
export type TicketGroupInfo = {
  ticket_group_id: number;
  /**
   * 门票组类型 1:套票；2:场次票
   */
  ticket_group_type: number;
  ticket_group_name: string;
  /**
   * 门票价格
   */
  ticket_price: number;
  /**
   * 已售数量
   */
  sale_num: number;
  /**
   * 库存
   */
  stock_num: number;
  /**
   * 时间类型，1: 跟随活动结束；2: 自定义时间
   */
  time_type: number;
  begin_time: number;
  end_time: number;
  time_zone: string;
  /**
   * 审批类型：1自动审批；2手动审批
   */
  approve_type: number;
  /**
   * 门票组状态 -1:已删除, 0:不可见, 1:可见
   */
  status: number;
  /**
   * 所属活动id
   */
  event_id: string;
  ticket_num: number;
}[];
export type TypeCount = {
  /**
   * 场地类型，1：大型会场
   */
  venue_type: number;
  /**
   * 数量
   */
  count: number;
}[];
export type VenueType = number[];
export interface DashboardEventInfoRes {
  msg?: string;
  data: Data;
  code?: number;
  nonce?: string;
}
export interface Data {
  /**
   * 活动ID
   */
  event_id: string;
  /**
   * 主办方ID
   */
  host_id: number;
  /**
   * 主办方名
   */
  host_name: string;
  /**
   * 活动主题
   */
  title: string;
  /**
   * 活动开始时间
   */
  start_time: number;
  /**
   * 活动结束时间
   */
  end_time: number;
  /**
   * 时区
   */
  time_zone: string;
  /**
   * 活动行业分类名
   */
  industry_name?: string;
  /**
   * 活动行业分类编码
   */
  industry_code?: string;
  labels: Labels;
  /**
   * 活动状态，未发布0，已发布1，发布中2，发布失败3， 修改发布中4，修改失败5
   */
  status: number;
  /**
   * 封面图url
   */
  cover_url: string;
  /**
   * 模板类型名
   */
  template: string;
  /**
   * 收费类型（免费传1，付费传2，免费+付费传3）
   */
  charge_type: number;
  /**
   * 活动类型，-1为旧版webinar，0位新版活动
   */
  event_type: number;
  /**
   * 是否公开，0为不公开，1为公开
   */
  is_public: number;
  /**
   * 活动地址
   */
  address: string;
  /**
   * 是否人工审核，0为机器审核，1为人工审核，2为黑名单活动
   */
  is_person_audit: number;
  /**
   * 审核状态：-1人工审核不通过；0待人工审核；1人工审核通过
   */
  audit_status: number;
  /**
   * 广场上架状态 0 未上架 1 已上架
   */
  plaza_status: number;
  ticket_info: TicketInfo;
  scheduler_info: SchedulerInfo;
  people_info: PeopleInfo;
  /**
   * 二次编辑状态，0 没有发生二次编辑，1 当前有二次编辑的内容
   */
  reedit_status: number;
  /**
   * 监管状态 0-正常状态 1-被监管屏蔽
   */
  regulatory_status: number;
  venue_type: VenueType;
  /**
   * 准入规则 0-门票准入 1-无限制准入
   */
  access_rule: number;
  address_ext: AddressExt;
}
export interface TicketInfo {
  /**
   * 门票最小价格。单位：分
   */
  min_fee: number;
  /**
   * 门票最大价格。单位：分
   */
  max_fee: number;
  /**
   * 门票数量
   */
  amount_num: string;
  /**
   * 库存数量
   */
  stock_num: string;
  ticket_group_info: TicketGroupInfo;
}
/**
 * 日程信息
 */
export interface SchedulerInfo {
  /**
   * 日程总数
   */
  total: string;
  type_count: TypeCount;
}
/**
 * 人员信息
 */
export interface PeopleInfo {
  /**
   * 主持人数量
   */
  host_count: number;
  /**
   * 嘉宾数量
   */
  guest_count: number;
  /**
   * 观众数量
   */
  audience_count: number;
}
export interface AddressExt {
  province: string;
  city: string;
  /**
   * 纬度
   */
  latitude: number;
  /**
   * 经度
   */
  longitude: number;
  citycode: string;
}

const DashboardEventInfo = async (data: Body, ctx?: GetServerSidePropsContext) => {
  const res = await http.post<DashboardEventInfoRes>(
    '/wemeet-tapi',
    '/v2/activities/dashboard/event/info',
    data,
    ctx,
  );

  return res;
};

export default DashboardEventInfo;
